import { render, staticRenderFns } from "./LayoutPublicWide.vue?vue&type=template&id=b77e6fb8"
import script from "./LayoutPublicWide.vue?vue&type=script&lang=js"
export * from "./LayoutPublicWide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports